import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { MetricResult } from '../../../../types/adminAnalytics.ts';
import {
  metricsToChartData,
  getSectionChartHeight,
} from '../../../../utils/analyticsChartData.ts';
import AnalyticsChartTooltip from './AnalyticsChartTooltip.tsx';
import styles from './AnalyticsCharts.module.scss';

const ACTUAL_COLOR = '#234ba2';
const PREVIOUS_COLOR = '#94a3b8';

interface AnalyticsSectionBarChartProps {
  metrics: MetricResult[];
  title: string;
  exportId: string;
}

const AnalyticsSectionBarChart: React.FC<AnalyticsSectionBarChartProps> = ({
  metrics,
  title,
  exportId,
}) => {
  const data = metricsToChartData(metrics);
  if (!data.length) return null;

  const height = getSectionChartHeight(metrics.length);

  return (
    <div
      className={styles.chartCard}
      data-analytics-export-chart={exportId}
    >
      <h4 className={styles.chartTitle}>{title}</h4>
      <div className={styles.chartBody} style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 8, right: 24, left: 8, bottom: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e8edf3" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 11 }} />
            <YAxis
              type="category"
              dataKey="name"
              width={140}
              tick={{ fontSize: 11 }}
            />
            <Tooltip content={<AnalyticsChartTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar
              dataKey="actual"
              name="Período actual"
              fill={ACTUAL_COLOR}
              radius={[0, 4, 4, 0]}
              isAnimationActive={false}
            />
            <Bar
              dataKey="anterior"
              name="Período anterior"
              fill={PREVIOUS_COLOR}
              radius={[0, 4, 4, 0]}
              isAnimationActive={false}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AnalyticsSectionBarChart;
